import React, { PureComponent } from "react";
import { Button } from "aible";

import LeakageChartContainer from "containers/Next/Charts/LeakageChart";
import NextChartContainer from "components/Next/Charts/NextChart";
import styles from "./style.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class ComparisonDashboardChart extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isHighlight: undefined,
      secondaryChartIndex: 0,
      expandChart: undefined,
      hoverLegend: undefined,
      sChartIndex: 0,
      maxLines: 3,
      showSecondary: false
    };
  }

  render() {
    return this.renderDashboard();
  }

  renderDashboard() {
    const {
      id,
      reportId,
      chart,
      dataset,
      datasetSuccess,
      isInfographic,
      isRight,
      sortType,
      useReportIdForChatGPTReducer
    } = this.props;
    const { showSecondary } = this.state;

    return (
      <div className={styles.dashboardChart}>
        {this.renderExpandModal()}
        <ChartTitle
          id={id}
          dataset={dataset}
          datasetSuccess={datasetSuccess}
          chart={chart}
          onClick={() => this.setState({ expandChart: chart })}
          sortType={sortType}
          isInfographic={isInfographic}
        />
        <div className={styles.dashboardChartInner} style={{ flexDirection: "column" }}>
          <div
            style={{
              height: isRight ? "90%" : showSecondary ? "calc(60% - 30px)" : "100%",
              width: "100%",
              zIndex: 10,
              position: "relative"
            }}
          >
            <NextChartContainer
              id={id}
              reportId={reportId}
              useReportIdForChatGPTReducer={useReportIdForChatGPTReducer}
              chart={chart}
              dataset={dataset}
              isReport={true}
              showTooltip={true}
              showLeakage={true}
              hideTitle
              isComparisonDashboard={true}
              isComparisonShowAll={isRight}
              isHideNarrative={isRight}
              isSmall={isRight}
            />
          </div>
        </div>
      </div>
    );
  }

  renderExpandModal() {
    const { id, chart, reportId } = this.props;
    const { expandChart, sChartIndex } = this.state;

    const retSecondaryCharts = chart?.relatedCharts;
    const retShowSecondary = retSecondaryCharts?.length > 0;

    return (
      <Dialog open={expandChart !== undefined} onOpenChange={() => this.setState({ expandChart: undefined })}>
        <DialogContent size="full">
          <DialogHeader>
            <DialogTitle>{expandChart?.narrative?.title}</DialogTitle>
          </DialogHeader>
          <div className={styles.comparisonModalBody}>
            {expandChart && (
              <div className={styles.comparisonModalChart} style={{ height: retShowSecondary ? "70%" : undefined }}>
                <NextChartContainer
                  id={id}
                  reportId={reportId}
                  chart={expandChart}
                  hideTitle
                  hidePin
                  isExpand
                  showLeakage={true}
                  showTooltip={true}
                  isComparisonDashboard={true}
                />
              </div>
            )}
            {retShowSecondary && (
              <div className={styles.cBotComparisonDashboardCharts} style={{ height: "30%" }}>
                <Button
                  disabled={sChartIndex <= 0}
                  onClick={() => this.setState({ sChartIndex: sChartIndex - 1 })}
                  style={{ border: "none", marginRight: "auto" }}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                </Button>
                {retSecondaryCharts &&
                  retSecondaryCharts
                    .filter((nChart, i) => i <= sChartIndex * 3 + 2 && i >= sChartIndex * 3)
                    .filter((nChart, i) => i < 3)
                    .map((nChart, cIndex) => (
                      <div className={styles.sChartTileComparisonDashboard} key={"sChart_" + cIndex}>
                        <NextChartContainer
                          id={id}
                          reportId={reportId}
                          chart={nChart}
                          isSmall={true}
                          hidePin={true}
                          isListChart={true}
                          showTooltip={true}
                          showLeakage={true}
                          showAxis={false}
                          isDashboard={true}
                          hideLegend={true}
                          showTitle={true}
                          isInfographic={true}
                          isHideNarrative={true}
                          isComparisonDashboard={true}
                          isExpandChart={this.state.expandChart?.title === nChart?.title}
                          updateIsExpandChart={() => {
                            this.setState({
                              expandChart: this.state.expandChart?.title === nChart?.title ? chart : nChart
                            });
                          }}
                        />
                      </div>
                    ))}
                <Button
                  disabled={retSecondaryCharts === undefined || (sChartIndex + 1) * 3 >= retSecondaryCharts.length}
                  onClick={() => this.setState({ sChartIndex: sChartIndex + 1 })}
                  style={{ border: "none", marginLeft: "auto" }}
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </Button>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

class ChartTitle extends PureComponent {
  render() {
    const { isInfographic, chart, onClick, id } = this.props;

    return (
      <div
        className={styles.dashboardComparisonChartTitleLayout}
        style={isInfographic ? { borderBottom: "none" } : undefined}
        onClick={onClick}
      >
        <div className={styles.tinyMuscleScoreDash} style={{ marginTop: "-2px", height: "110px", width: "100px" }}>
          <LeakageChartContainer
            id={id}
            height={110}
            width={110}
            innerRadius={13}
            node={chart}
            insight={chart}
            isTiny
            hideChords={true}
            isDashboard
          />
          <div className={styles.tinyScore} style={chart?.rank + 1 >= 10 ? { marginLeft: "-4px" } : {}}>
            {chart?.rank + 1}
          </div>
        </div>
        <div className={styles.dashboardCOmparisonChartTitle}>{chart?.title}</div>
      </div>
    );
  }
}
